import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { userType } from 'types';
import './style.scss';

const ProjectAvatar = ({ user, className }) =>
  user ? (
    <img
      src={user.avatar_url}
      title={user.username}
      alt={user.username}
      styleName="avatar"
      className={className}
      data-test="avatar-icon"
    />
  ) : (
    <i
      className={cn('icon-user', className)}
      styleName="default-icon"
      data-test="default-icon"
    />
  );

ProjectAvatar.propTypes = {
  user: userType,
  className: PropTypes.string,
};

export default ProjectAvatar;
